export class AttributesKeys {
    public id: number;
    public attributeKey: String;
    public lastUpdate: Date;
    public updatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/models/attributekeys.ts